<!--
Анонимная авторизация менеджером
-->
<template>
    <div class="loading_wrapper">
        <LoadingIndicator class="primary big"></LoadingIndicator>
        <ErrorPopup
            :show="auth_error"
            v-on:closeEvent="PopupCloseEvent"
            :popup_header="error_title"
            :popup_description="error_description"
        ></ErrorPopup>
    </div>
</template>

<script>
    import CheckBox from '@/components/checkbox/CheckBox.vue'
    import lStorage from '../../store/localStorage.js';
    import Cookie from '@/store/cookie.js';
    import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import ErrorPopup from '@/views/pages/manager_popups/ErrorPopup';

    export default {
        name: 'ManagerLoginPage',
        components: {
            CheckBox,
            LoadingIndicator,
            ErrorPopup
        },
        data:function(){
            return {
                loading: false,
                auth_error:false,
                error_title:"",
                error_description:""
            }
        },
        mounted(){
            //Попробуем авторизироваться. Для этого сначала стираем свой токен
            lStorage.set('auth-token',null);
            Cookie.set("auth-token",null,{
                "max-age":3600*30,
                "domain":"."+env.domain
            });

            if(this.$route.query.token){
                //Теперь пробуем пройти авторизацию
                rest.call("get_lead",{
                    'session': this.$route.query.token,
                },"POST").then((response)=>{
                    if(response.token){
                        lStorage.set('auth-token', response.token);
                        Cookie.set("auth-token",response.token,{
                            "max-age":3600*30,
                            "domain":"."+env.domain
                        });
                        if(response.language){
                            i18n.locale = response.language;
                        }
                        this.$router.push({
                            name:"lesson",
                            params:{
                                locale:i18n.locale,
                            }
                        });
                    }
                }).catch((error)=>{
                    this.error_title = i18n.t("managers.AUTH_FAILURE");
                    this.error_description = null;
                    this.auth_error=true;
                });
            }else{
                this.error_title = i18n.t("managers.TOKEN_NOT_PASSED");
                this.error_description = i18n.t("managers.TOKEN_NOT_PASSED_DESCRIPTION");
                this.auth_error=true;
            }
        },
        methods: {
            PopupCloseEvent(){
                this.auth_error = false;
                
                this.$router.push({
                    name:"LoginPage",
                    params:{
                        locale:i18n.locale,
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .loading_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100%;
    }
</style>